import React, { memo, useMemo } from 'react'

import { Button, Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function ButtonSelector({
  id,
  label,
  onClick:
  handleClick,
  sliceName,
  keyName,
  disabled = false,
  isActive: isActiveFromProp,
  tooltipMessage = undefined,
}) {
  const isActiveFromStore = useThreeDStudioStore(
    state => state?.[sliceName]?.[keyName] === id
  )
  const mergedIsActive = useMemo(() => {
    if (isActiveFromProp !== undefined && isActiveFromProp !== null) {
      return isActiveFromProp
    }

    return isActiveFromStore
  }, [isActiveFromProp, isActiveFromStore])

  const button = (
    <Button
      type="secondary"
      size="tiny"
      onClick={handleClick}
      isActive={mergedIsActive}
      customClass="button-group-selector__button"
      disabled={disabled}
    >
      {label}
    </Button>
  )

  if (!tooltipMessage) {
    return button
  }

  return (
    <Tooltip
      content={tooltipMessage}
      id={`button-selector-tooltip-${id}`}
      containerClass="button-group-selector__tooltip"
      className="button-group-selector__tooltip-trigger"
    >
      {button}
    </Tooltip>
  )
}

ButtonSelector.propTypes = {
  id: string.isRequired,
  keyName: string.isRequired,
  label: string.isRequired,
  onClick: func.isRequired,
  sliceName: string.isRequired,
  disabled: bool,
  isActive: bool,
  tooltipMessage: string,
}

export default memo(ButtonSelector)
